/** Production invitation / Universal Links host (join.pebla.app). */
export const JOIN_HOST = 'join.pebla.app';

export const downloadLinks = {
    appStore: 'https://apps.apple.com/us/app/pebla-track-mobile-money-pay/id6748704464',
    playStore: 'https://play.google.com/store/apps/details?id=com.pebla.pebla&pcampaignid=web_share',
};